import { activeTablesTypes, playerPrivacyStatusesEnum } from 'shared/models/LastWins'

import { ILastWinsStatePersisted } from 'features/lastWins/types'

type ReturnMigrationType = (state: ILastWinsStatePersisted) => ILastWinsStatePersisted

export const lastWinsMigrations: Record<string, ReturnMigrationType> = {
  1: state => ({
    ...state,
    data: {
      ...state.data,
      privacySettings: {
        hideMode: playerPrivacyStatusesEnum.none,
        isNickHidden: false,
        activeTables: [],
      },
      currentActiveTable: activeTablesTypes.standard,
      // slotsWinsTableType: tableTypesEnum.lastBets,
      slotsWinsPageSize: 10,
      slotsWins: {
        page: 1,
        count: 0,
        wins: [],
      },
    },
  }),
  2: state => ({
    ...state,
    data: {
      ...state.data,
      slotsWinsPageSize: 6,
      slotsWinsPage: 1,
      slotsWins: {
        page: 1,
        count: 0,
        wins: [],
      },
    },
  }),
}
